module.exports = __webpack_public_path__ + "img/file.2b90f5a4.svg";